import React, { useEffect, useState } from "react";
import {
    AutocompleteInput,
    Create,
    SaveButton, SimpleForm, TextInput, Toolbar, required, useGetOne
} from "react-admin";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";
import PeopleIcon from '@mui/icons-material/People';
import { getAllSubMerchant } from "../../services/SubMerchant";
import Color from "../layout/color/Color";
import FontSize from "../layout/FontSize";

const RoleList = [
    {
        id: 1,
        name: 'Master Manager',
    },
    {
        id: 2,
        name: 'Manager'
    },
    {
        id: 3,
        name: 'Cashier'
    }
]

const saveButton = {
    bgcolor: Color.Main,
    borderRadius: '30px',
    border: '1px solid Color.Main',
    fontWeight: '500',
    textAlign: 'center',
    padding: '8px 15px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Button, color: Color.Normal }
};

const backButton = {
    bgcolor: Color.Button,
    borderRadius: '30px',
    border: "1px solid #055C2D",
    color: Color.Main,
    fontWeight: '500',
    textAlign: 'center',
    padding: '8px 15px',
    transition: '0.3s',
    fontSize: FontSize.Medium,
    textTransform: 'none',
    '&:hover': { background: Color.Main, color: Color.Button }
};

const EmployeeCreateToolbar = (props) => {
    const navigate = useNavigate();
    const handleBack = (e) => {
        e.preventDefault();
        navigate('/Employee')
    }
    return (
        <Toolbar sx={{ justifyContent: 'space-between' }} {...props}>
            <Button
                startIcon={<KeyboardBackspaceIcon />}
                onClick={handleBack}
                sx={backButton}
            >
                Back
            </Button>
            <SaveButton variant="contained" sx={saveButton} />
        </Toolbar>
    )
}

export const EmployeeCreate = (props) => {
    const [submerchants, setSubmerchants] = useState([]);
    const [parentSubmerchant, setParentSubmerchant] = useState(null)
    const { data } = useGetOne('Employee', {});

    useEffect(() => {
        if (data !== undefined) {
            setParentSubmerchant(data.submerchantID);
            getAllSubMerchant().then((result) => {
                setSubmerchants(result.allSubMerchants);
            }).catch((err) => {
                console.log(err);
            })
        }
    }, [data]);

    return (submerchants !== []) && (
        <Create {...props}>
            <SimpleForm toolbar={<EmployeeCreateToolbar />}>
                <Grid sx={{ textAlign: 'left' }}>
                    <Button endIcon={<PeopleIcon sx={{ color: Color.Main }} />} size="medium">
                        <Typography variant="h3">
                            Create Employee
                        </Typography>
                    </Button>
                </Grid>
                <Divider sx={{ width: '100%', mb: 2 }} />
                <Grid sx={{ display: 'flex', p: 3, width: '100%', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <Grid container={true} sx={{ alignItems: 'center', justifyContent: 'center', width: { xs: '100%', md: '80%' } }}>
                        <Grid item xs={0} md={4} lg={2} sx={{ textAlign: 'center' }}>
                        </Grid>
                        <Grid item xs={12} md={8} lg={10} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{ width: { xs: '100%', md: '80%', lg: '50%' } }}>
                                <AutocompleteInput
                                    source="submerchantID"
                                    optionText="name"
                                    label="SubMerchant name"
                                    choices={submerchants}
                                    defaultValue={parentSubmerchant}
                                />
                            </Box>
                        </Grid>
                        <Divider sx={{ width: '100%' }} />
                        <Grid item xs={12} sx={{ p: 3 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="username" label="Username" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="fullname" label="Fullname" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="address" label="Address" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="phone" label="Phone number" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <TextInput required source="email" label="Email" fullWidth variant="outlined" />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <AutocompleteInput
                                            optionText='name'
                                            source="role"
                                            choices={RoleList}
                                            validate={required()}
                                            variant="outlined"
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    )
}
